import { render, staticRenderFns } from "./LessonWordsInfoDialog.vue?vue&type=template&id=bd92810a&"
import script from "./LessonWordsInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./LessonWordsInfoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports